/**
 * Strict Mode Utility
 *
 * Session-scoped strict mode toggle for developer debugging.
 * When enabled, error boundaries (QuestionErrorBoundary, PracticeErrorBoundary)
 * will NOT catch errors — they render children directly, letting errors propagate.
 *
 * Uses sessionStorage so it resets on browser refresh/tab close.
 * This is intentional: strict mode is a debugging tool, not a persistent setting.
 *
 * In this phase, enabling strict mode WILL crash the app on question renderer errors.
 * That's the intended behavior for debugging.
 */

const STRICT_MODE_KEY = 'meesterjay_strict_mode';

/**
 * Check if strict mode is currently enabled.
 * Returns false if sessionStorage is unavailable.
 */
export function isStrictMode(): boolean {
  try {
    return sessionStorage.getItem(STRICT_MODE_KEY) === 'true';
  } catch {
    return false;
  }
}

/**
 * Enable or disable strict mode.
 * Persists to sessionStorage (cleared on tab close / refresh).
 */
export function setStrictMode(enabled: boolean): void {
  try {
    if (enabled) {
      sessionStorage.setItem(STRICT_MODE_KEY, 'true');
    } else {
      sessionStorage.removeItem(STRICT_MODE_KEY);
    }
  } catch {

    // sessionStorage unavailable — silently fail
  }
}